import RegionDatePicker, { getStartOfDay } from '@/components/RegionDatePicker'
import WarningAlert from '@/pages/order/components/WarningAlert'
import { Switch } from '@roo/roo'
import dayjs from 'dayjs'
import React, { ReactElement, useState } from 'react'

const todayStart = getStartOfDay()
const next3MonthStart = dayjs(todayStart).add(3, 'month')
  .valueOf()

interface Props {
  label: ReactElement
  value?: number | undefined
  onChange?: (val: Props['value']) => void
  showTip: boolean
}

const SwithDatePicker = (props: Props) => {
  const [enable, setEnable] = useState(Boolean(props.value))
  const { onChange: propChange = () => {} } = props


  return (
    <div>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <label>{props.label}&ensp;&ensp;</label>
        <Switch value={enable}  size="mini" onChange={(val) => {
          setEnable(val)
          if (!val) { // 关闭开关,清空值
            propChange(undefined)
          } else if (!props.value) { // 打开开关,增加默认值
            propChange(dayjs(todayStart).add(1, 'day')
              .valueOf())
          }
        }}/>
        {enable && (
          <>
          &ensp;&ensp;
            <div style={{ flex: 1 }}>
              <RegionDatePicker
                disabledDate={cur => {
                  const curTime =  cur.valueOf()
                  return curTime < todayStart || curTime > next3MonthStart
                }}
                value={props.value}
                onChange={propChange}
                timeSteps={{ minuteStep: 5, secondStep: 60 }}
              />
            </div>
          </>
        )}
      </div>
      {props.showTip && enable && <WarningAlert />}
    </div>
  )
}
export default SwithDatePicker